type IOSDeviceIds = {
  idfa: string;
  idfv: string;
};

type AndroidDeviceIds = {
  aid: string;
  gaid: string;
  asid: string;
};
interface FirebaseEventMapping {
  [key: string]: string;
}
type DeviceIds = IOSDeviceIds | AndroidDeviceIds;
declare global {
  interface Window {
    sourceDetails?: DeviceIds;
    appVersion?: string;
  }
}
export const APP_EVENTS = {
  APP_LAUNCHED: "app_launched",
  PAGE_VIEWED: "page_viewed",
  PROPERTY_VIEWED: "property_viewed",
  PROPERTY_WISHLISTED: "property_wishlisted",
  SECTION_INTERACTED: "section_interacted",
  MODAL_INTERACTED: "modal_interacted",
  CTA_CLICKED: "cta_clicked",
  LEAD_CTA_CLICKED: "lead_cta_clicked",
  CARD_CLICKED: "card_clicked",
  FILTER_CTA_CLICKED: "filter_cta_clicked",
  FILTER_APPLIED: "filter_applied",
  USER_LOGIN: "user_login",
  USER_LOGOUT: "user_logout",
  PERMISSIONS_PROMPTED: "permissions_prompted",
  BANNER_SHOWN: "banner_shown",
  LEAD_CREATED: "lead_created",
  PARTIAL_BOOKFORM_SUBMITTED: "partial_bookform_submitted",
  BOOKFORM_SUBMITTED: "bookform_submitted",
  PAYMENT_CREATED: "payment_created",
  PAYMENT_SUCCESSFUL: "payment_successful",
  PAYMENT_FAILED: "payment_failed",
  UI_ELEMENT_INTERACTED: "ui_element_interacted",
  LANGUAGE_CHANGED: "language_changed",
};

export const CLICKED_ITEM = {
  CLEAR_FILTER: "clear_filter",
  OPEN_MAP: "open_map",
  VIEW_MAP: "view_map",
  RECENTLY_SEARCHED: "recently_searched",
  POPULAR_LOCATIONS: "popular_locations",
  TOP_UNIVERSITIES: "top_universities",
};

export const APP_TROVE_EVENTS: { [key: string]: string } = {
  user_login: "bcqkylvMoI",
  page_viewed: "4Zsr136Ayl",
  lead_created: "H0FX0MIxlA",
  submit_lead_form_1: "H0FX0MIxlA",
  bookform_submitted: "Q9BawDsVZr",
  submit_book_form: "Q9BawDsVZr",
};

export const firebaseEventMapping: FirebaseEventMapping = {
  lead_created: "submit_lead_form_1",
  bookform_submitted: "submit_book_form",
};

export const singularEventMapping: { [key: string]: string } = {
  lead_created: "submit_lead_form_1",
  bookform_submitted: "submit_book_form",
};

export const APP_PAGE = {
  HOME: "home",
  SEARCH: "search_page",
  PROPERTY: "property_page",
  BOOKING: "booking_page",
  BOOKING_SUCCESS: "booking_success_page",
  APPLICATION: "application_page",
  PAYMENT: "payment_page",
  PAYMENT_FAILURE: "payment_failure_page",
  PAYMENT_SUCCESS: "payment_success_page",
  LEAD_FORM: "lead_form_page",
  PROFILE: "profile_page",
  SUPPORT: "support_page",
  MY_ACTIVITY: "my_activity_page",
  MY_BOOKINGS: "my_bookings_page",
  REFFERAL: "refferal_page",
  AMBASSADOR: "ambassador_page",
  EXAMS: "exams_page",
  SCHOLARSHIP: "scholarship_page",
  SCHOLARSHIP_NEW: "scholarship_new_page",
  CAREER: "career_page",
  JOBS: "jobs_page",
  OFFERS: "offers_page",
  GALLERY_MODAL: "gallery_modal",
  ROOM_TYPE_DETAILS: "room_type_details_page",
  PROFILE_REFFERAL: "profile_refferal_page",
  PROFILE_SHORTLIST: "profile_shortlist_page",
  PROFILE_SUPPORT: "profile_support_page",
  USER_REVIEW_SCREEN: "user_review_screen_page",
  AMBER_PLUS: "amber_plus_page",
  CUSTOM_PAYMENT: "custom_payment_page",
  AMBER_PLUS_SERVICE: "amber_plus_service_page",
  SHORTLIST: "shortlist_page",
  SETTINGS: "settings_page",
  BLOG_HOME: "blog_home_page",
  BLOG_POST: "blog_post_page",
  BLOG_GRID: "blog_grid_page",
  BLOG_CATEGORY: "blog_category_page",
  BLOG_TAG: "blog_tag_page",
  BLOG_SEARCH: "blog_search_page",
  BLOG_DRAFTS: "blog_drafts_page",
  NEWS_HOME: "news_home_page",
  NEWS_GRID: "news_grid_page",
  NEWS_POST: "news_post_page",
  NEWS_AMBER_REPORT: "news_amber_report_page",
  NEWS_AMBER_BEAT: "news_amber_beat_page",
  NEWS_CATEGORY: "news_category_page",
  NEWS_TAG: "news_tag_page",
  NEWS_SEARCH: "news_search_page",
  FILTER_MODAL: "filter_modal_page",
};

export const filterTypeMap: Record<string, string> = {
  Sort: "sortBy",
  Locality: "locality",
  University: "university",
  Budget: "budget",
  "Move in Month": "moveInMonth",
  "Stay Duration": "stayDuration",
  "Room Type": "roomType",
};

export const FILTER_FLOW = {
  MAIN_FILTER: "main_filter",
  PREFERENCES_FILTER: "preferences_filter",
  INLINE_FILTER: "inline_filter",
  QUICK_FILTER: "quick_filter",
};

export const FILTER_MODE = {
  MAP_VIEW: "map_view",
  LISTING_VIEW: "listing_view",
};

export enum WEB_VIEW_APP_EVENTS {
  LOGIN_CLICKED = "LOGIN_CLICKED",
  USER_AUTH_TOKEN = "USER_AUTH_TOKEN",
  AMPLITUDE_EVENT = "AMPLITUDE_EVENT",
  SINGULAR_EVENT = "SINGULAR_EVENT",

  INITIATE_STRIPE_SHEET = "INITIATE_STRIPE_SHEET",
  META_EVENT = "META_EVENT",
  SINGULAR_DEEPLINK = "SINGULAR_DEEPLINK",
  LOG = "log",
  ERROR = "error",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  ZENDESK_TOGGLE = "ZENDESK_TOGGLE",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  OPEN_EXTERNAL_URL = "OPEN_EXTERNAL_URL",
  WEB_CRASH = "WEB_CRASH",
  BACK_ACTION_TRIGGERED = "BACK_ACTION_TRIGGERED",
  REQUEST_IN_APP_REVIEW = "REQUEST_IN_APP_REVIEW",
  FEEDBACK_SUBMITTED = "FEEDBACK_SUBMITTED",
  IDLE_TIMER_START = "IDLE_TIMER_START",
  IDLE_TIMER_CANCEL = "IDLE_TIMER_CANCEL",
  LANGUAGE_CHANGED = "LANGUAGE_CHANGED",
  CURRENCY_CHANGED = "CURRENCY_CHANGED",
  FCM_TOKEN_UPDATED = "FCM_TOKEN_UPDATED",
}

export enum IdleTimerStage {
  LEAD_FORM = "lead_form",
  BOOK_FORM = "book_form",
  PAYMENT = "payment",
}

export const getAppSourceDetails = () => {
  const appSource = __CLIENT__ && window?.sourceDetails;
  const appVersion = __CLIENT__ && window?.appVersion;
  if (appSource && appVersion) {
    return { ...appSource, app_version: appVersion };
  }
  return {};
};
